/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomFscHdr.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/custom-fsc-hdr";

export class AutogenModelCustomFscHdr<RowType extends ModelRow> extends Endpoint<RowType, RowCustomFscHdrFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomFscHdr extends ModelRow<RowCustomFscHdrFields> {
	constructor(values?: Partial<RowCustomFscHdrFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomFscHdrFields {
	company_id: string;
	descr: string;
	id: string;
}

